import http from "@/shared/services/http";
import {CustomerRegisterParams} from "@/modules/customerregister/params";

export const singleCustomerRegister = (id: number) => http.get(`v1/customer-registers/${id}`);
export const listCustomerRegister = (params?: CustomerRegisterParams) => http.get(`v1/customer-registers`, {params});
export const deleteCustomerRegister = (id: number) => http.delete(`v1/customer-registers/${id}`);
export const confirmCustomerRegister = (id: number, data: any) => http.post(`v1/customer-registers/${id}`, data );
